import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Select,
  MenuItem,
  TextField,
  FormHelperText,
  FormControl,
  InputAdornment,
  Modal,
  Box,
  List,
  ListItem,
  ListItemText
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { format } from 'date-fns';

const FormFilterCard = ({ title, fields, onPatientSelect, filteredPatients = [], handleSearchChange, searchQuery, setSearchQuery, showErrors }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handlePatientSelect = (patient) => {
    onPatientSelect(patient);
    setModalOpen(false);
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" fontWeight={600} mb={2}>
          {title?.toUpperCase()}
        </Typography>
        <Grid container spacing={1}>
          {fields.map((field, index) => (
            <Grid item xs={12} md={field.fullWidth ? 12 : 6} key={index} className="w-100">
              {field.type === "select" ? (
                <FormControl fullWidth size="small" required >
                  <Select
                    variant="outlined"
                    displayEmpty
                    value={field.value || ""}
                    onChange={(e) => {
                      field.onChange?.(e.target.value)
                    }
                    }
                  >
                    {field.options.map((option, i) => (
                      <MenuItem key={i} value={option.id}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : field.type === "datePicker" ? (
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Birth date"
                    inputFormat="dd-MM-yyyy"
                    value={field.value ? new Date(field.value) : null}
                    onChange={(newValue) =>
                      field.onChange?.(newValue ? format(newValue, 'yyyy-MM-dd') : null)
                    }
                    disableFuture
                    disabled={field.disabled}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: 'small',
                        required: true,
                        placeholder: 'dd-mm-yyyy',
                        className: 'w-100',
                        inputProps: {
                          style: {
                            padding: '10px',
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              ) :
                (
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    label={field.placeholder}
                    type={field.type || "text"}
                    required
                    error={showErrors && ["firstName", "lastName", "birthDay", "gender"].includes(field.name) && !field.value}
                    helperText={showErrors && ["firstName", "lastName", "birthDay", "gender"].includes(field.name) && !field.value ? "This field is required" : ""}
                    InputProps={{
                      startAdornment:
                        field.name === "search" ? (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ) : null,
                    }}
                    onChange={(e) => field.onChange?.(e.target.value)}
                    value={field.value || ""}
                    onClick={field.name === "search" ? () => setModalOpen(true) : undefined}
                    disabled={field.disabled}
                  />
                )}
            </Grid>
          ))}
        </Grid>
      </CardContent>

      {/* Search Modal */}
      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            width: 500,
          }}
        >
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            label="Search Patient"
            value={searchQuery}
            onChange={handleSearchChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <List sx={{ paddingTop: 0, paddingBottom: 0 }}>
            {filteredPatients.length > 0 ? (
              filteredPatients.map((patient, index) => (
                <ListItem
                  button
                  key={index}
                  onClick={() => handlePatientSelect(patient)}
                  sx={{
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    paddingTop: 0,
                    paddingBottom: 0,
                  }}
                >
                  <ListItemText
                    primary={patient.patientsName}
                    secondary={`DOB: ${patient.birthDay} | Gender: ${patient.gender}`}
                  />
                </ListItem>
              ))
            ) : (
              <Typography textAlign="center">No results found</Typography>
            )}
          </List>
        </Box>
      </Modal>
    </Card>
  );
};

export default FormFilterCard;
